module.exports = __webpack_public_path__ + "assets/img/card-bg-attack.e119fdc9.png";